import { render } from "./AddOffering.vue?vue&type=template&id=cf8bff14&scoped=true"
import script from "./AddOffering.vue?vue&type=script&lang=js"
export * from "./AddOffering.vue?vue&type=script&lang=js"

import "./AddOffering.vue?vue&type=style&index=0&id=cf8bff14&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8bff14"]])

export default __exports__